/**
 * Ordre des notes : positions flottantes, triées par ordre décroissant
 * (la note la plus haute dans la grille a la plus grande position).
 * Déplacer une note ne modifie qu'une seule ligne, sauf quand l'écart entre
 * deux voisines devient trop petit : il faut alors renuméroter.
 */
export const MIN_POSITION_GAP = 1e-6;

/**
 * Calcule la position d'une note insérée entre `above` (affichée avant) et `below` (affichée après).
 * Renvoie `null` si l'écart est trop faible et qu'une renumérotation est nécessaire.
 */
export function positionBetween(above: number | null, below: number | null): number | null {
  if (above === null && below === null) return 0;
  if (above === null) return (below as number) + 1;
  if (below === null) return above - 1;
  if (above - below < MIN_POSITION_GAP * 2) return null;
  return (above + below) / 2;
}
